// Twilio access tokens are JWTs; only `exp` is read, the signature is not checked.

export const TOKEN_REFRESH_LEAD_MS = 5 * 60 * 1000;
export const MIN_TOKEN_REFRESH_DELAY_MS = 30 * 1000;

const decodeBase64Url = (segment: string): string => {
  const base64 = segment.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
  return atob(padded);
};

// Epoch ms at which the token expires, or null when it cannot be decoded.
export const tokenExpiryMs = (token: unknown): number | null => {
  if (typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length !== 3 || !parts[1]) return null;
  try {
    const payload = JSON.parse(decodeBase64Url(parts[1]));
    const exp = payload?.exp;
    if (typeof exp !== 'number' || !Number.isFinite(exp) || exp <= 0) return null;
    return exp * 1000;
  } catch (e) {
    return null;
  }
};

export const tokenRemainingMs = (token: unknown, now: number = Date.now()): number | null => {
  const exp = tokenExpiryMs(token);
  return exp === null ? null : exp - now;
};

// Refresh no later than TOKEN_REFRESH_LEAD_MS before expiry and never sooner
// than MIN_TOKEN_REFRESH_DELAY_MS; maxDelayMs alone when exp is unknown.
export const tokenRefreshDelayMs = (
  token: unknown,
  maxDelayMs: number,
  now: number = Date.now()
): number => {
  const remaining = tokenRemainingMs(token, now);
  if (remaining === null) return maxDelayMs;
  return Math.max(
    MIN_TOKEN_REFRESH_DELAY_MS,
    Math.min(maxDelayMs, remaining - TOKEN_REFRESH_LEAD_MS)
  );
};
